import React from 'react';
import GeneralError from './general';
import { AppInsightsContext, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import isNil from 'lodash/isNil';

export interface ErrorBoundaryProps {
    message?: string;
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    static contextType = AppInsightsContext;

    state: ErrorBoundaryState = { hasError: false };

    static getDerivedStateFromError(_: Error) {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        const ai = this.context as ReactPlugin;
        if (!isNil(ai) && typeof ai.trackException === 'function') {
            ai.trackException({
                exception: error,
                properties: { componentStack: errorInfo.componentStack },
            });
        }
    }

    render() {
        if (this.state.hasError) return <GeneralError message={this.props.message} />;
        return this.props.children;
    }
}

export default ErrorBoundary;
